<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> ponderación de riesgos <span *ngIf="action == 'Delete'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content fxLayout="column">
  <div fxFlex>
    <mat-form-field *ngIf="action != 'Delete'" fxFlex>
      <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre" [disabled]="action == 'View'">
    </mat-form-field>
  </div>
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input placeholder="Moneda" matInput [(ngModel)]="LOCAL_DATA.moneda" [disabled]="action == 'View'" step ="0.1" type="number" min="0.1" max="9.9" (ngModelChange)="recalcularAcumulado()">
        </mat-form-field>
    </div>
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input placeholder="Origen de los fondos" matInput [(ngModel)]="LOCAL_DATA.origenDeFondos" [disabled]="action == 'View'" step ="0.1" type="number" min="0.1" max="9.9" (ngModelChange)="recalcularAcumulado()">
        </mat-form-field>
    </div>
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input placeholder="Sector de actividad" matInput [(ngModel)]="LOCAL_DATA.sectorDeActividad" [disabled]="action == 'View'" step ="0.1" type="number" min="0.1" max="9.9" (ngModelChange)="recalcularAcumulado()">
        </mat-form-field>
    </div>
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input placeholder="País de operación" matInput [(ngModel)]="LOCAL_DATA.paisDeOperacion" [disabled]="action == 'View'" step ="0.1" type="number" min="0.1" max="9.9" (ngModelChange)="recalcularAcumulado()">
        </mat-form-field>
    </div>
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input placeholder="País de residencia del cliente" matInput [(ngModel)]="LOCAL_DATA.paisDeResidenciaDelCliente" [disabled]="action == 'View'" step ="0.1" type="number" min="0.1" max="9.9" (ngModelChange)="recalcularAcumulado()">
        </mat-form-field>
    </div>
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input placeholder="País de residencia del beneficiario" matInput [(ngModel)]="LOCAL_DATA.paisDeResidenciaDelBeneficiario" [disabled]="action == 'View'" step ="0.1" type="number" min="0.1" max="9.9" (ngModelChange)="recalcularAcumulado()">
        </mat-form-field>
    </div>

    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input placeholder="País de residencia del relacionado" matInput [(ngModel)]="LOCAL_DATA.paisDeResidenciaDelRelacionado" [disabled]="action == 'View'" step ="0.1" type="number" min="0.1" max="9.9" (ngModelChange)="recalcularAcumulado()">
        </mat-form-field>
    </div>
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input placeholder="PEP" matInput [(ngModel)]="LOCAL_DATA.pep" [disabled]="action == 'View'" step ="0.1" type="number" min="0.1" max="9.9" (ngModelChange)="recalcularAcumulado()">
        </mat-form-field>
    </div>
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input placeholder="Tolerancia al riesgo" matInput [(ngModel)]="LOCAL_DATA.toleranciaAlRiesgo" [disabled]="action == 'View'" step ="0.1" type="number" min="0.1" max="9.9">
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
  <button mat-button (click)="doAction()" *ngIf="action != 'View'" [disabled]="acumulado!=100">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
    <!-- alinear a la derecha -->
    <h3 [ngClass]="{'red-text': acumulado>100,
                    'green-text': acumulado==100,
                    'yellow-text': acumulado<100}" style="margin-left: auto;">Acumulado: {{acumulado}}</h3>
</div>
